export var UploadArea;
(function (UploadArea) {
    UploadArea["sc"] = "sc";
    UploadArea["ml"] = "ml";
    UploadArea["da"] = "da";
    UploadArea["avatar"] = "avatar";
})(UploadArea || (UploadArea = {}));
